import React, { useState } from 'react';
import './CommodityCardMinimal.css';
import config from '../../../config';
import { FiPackage } from 'react-icons/fi';

const toPersianNumber = (n) => {
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return n ? n.toString().replace(/\d/g, (x) => farsiDigits[x]) : '';
};

function CommodityCardMinimal({ commodity, onAdd, badge, onOpenModal }) {
    const [imgError, setImgError] = useState(false);

    return (
        <div className="commodity-card-minimal" onClick={(e) => {
            e.stopPropagation();
            if (onOpenModal) onOpenModal();
        }}>
            <div className="minimal-image-wrapper">
                {commodity.image_path && !imgError ? (
                    <img
                        src={`${config.api.imageURL}/${commodity.image_path}`}
                        alt={commodity.title}
                        onError={() => setImgError(true)}
                    />
                ) : (
                    <div className="image-placeholder" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#999' }}>
                        <FiPackage size={40} />
                    </div>
                )}
            </div>

            <div className="minimal-title">
                {toPersianNumber((commodity.title ?? '').substring(0, 30))}
                {commodity.title?.length > 30 ? '...' : ''}
            </div>
        </div>
    );
}

export default CommodityCardMinimal;
